import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { ApplicationRef } from '@angular/core';
import { environment } from './environments/environment';

bootstrapApplication(AppComponent, appConfig)
  .then((value: ApplicationRef) => {
    environment.mains.forEach((main: { name: string; url: string }) => {
      ['main.js', 'polyfills.js', 'styles.css'].forEach((file: string) => {
        const script = document.createElement('script');
        const filename = (main as any)[file] ?? file;
        script.type = 'module';
        script.async = true;
        script.src = `${main.url}/${filename}`;
        document.body.appendChild(script);
      });
    });
  })
  .catch((err) => console.error(err));
